export default "__VITE_ASSET__BpDFHnD5__"